import { ViewEnum, type PageType } from '@shared/hooks';
import type { AuthTokenResponse } from '@shared/api';

export interface LocalAuthData extends AuthTokenResponse {
  expiresDate: number;
}

const TOKEN = 'token';
const THEME_IS_DARK = 'isDark';
const MENU_IS_COLLAPSED = 'menuIsCollapsed';
const PAYMENT_TRANSACTIONS_COLUMNS = 'paymentTransactionsColumns';
const CARD_TRANSACTIONS_COLUMNS = 'cardTransactionsColumns';
const VIEW = 'view';
const COUNT_PER_PAGE = 'countPerPage';

export class LocalStorageUtils {
  public static getAuthData = (): LocalAuthData | undefined => {
    const authDataJson = localStorage.getItem(TOKEN);
    return authDataJson ? JSON.parse(authDataJson) : undefined;
  };
  public static updateAuthData = (value: LocalAuthData) => localStorage.setItem(TOKEN, JSON.stringify(value));
  public static clearAuthData = () => localStorage.removeItem(TOKEN);

  public static getPaymentTransactionColumns = () => {
    const columns = localStorage.getItem(PAYMENT_TRANSACTIONS_COLUMNS);
    return columns ? JSON.parse(columns) : undefined;
  };
  public static setPaymentTransactionColumns = (value: string[]) => localStorage.setItem(PAYMENT_TRANSACTIONS_COLUMNS, JSON.stringify(value));

  public static getCardTransactionColumns = () => {
    const columns = localStorage.getItem(CARD_TRANSACTIONS_COLUMNS);
    return columns ? JSON.parse(columns) : undefined;
  };
  public static setCardTransactionColumns = (value: string[]) => localStorage.setItem(CARD_TRANSACTIONS_COLUMNS, JSON.stringify(value));

  public static getThemeIsDark = () => {
    const theme = localStorage.getItem(THEME_IS_DARK);
    if (theme === 'true') return true;
    return false;
  };
  public static setThemeIsDark = (isDark: boolean) => localStorage.setItem(THEME_IS_DARK, isDark.toString());

  public static getMenuIsCollapsed = () => {
    const theme = localStorage.getItem(MENU_IS_COLLAPSED);
    if (theme === 'true') return true;
    return false;
  };
  public static setMenuIsCollapsed = (isDark: boolean) => localStorage.setItem(MENU_IS_COLLAPSED, isDark.toString());

  public static getView = (): Partial<Record<PageType, ViewEnum>> => {
    const view = localStorage.getItem(VIEW);
    return view ? JSON.parse(view) : {};
  };
  public static setView = (data: Partial<Record<PageType, ViewEnum>>) => {
    const view = this.getView();
    localStorage.setItem(VIEW, JSON.stringify({ ...view, ...data }));
  };

  public static getCountPerPage = (): Partial<Record<string, number>> => {
    const countPerPage = localStorage.getItem(COUNT_PER_PAGE);
    return countPerPage ? JSON.parse(countPerPage) : {};
  };
  public static setCountPerPage = (data: Partial<Record<string, number>>) => {
    const countPerPage = this.getCountPerPage();
    localStorage.setItem(COUNT_PER_PAGE, JSON.stringify({ ...countPerPage, ...data }));
  };
}
